import plantumlEncoder from "plantuml-encoder";
import {
  classNameParkerPrefix as prefixPk,
  classNamePrefix as prefixCt,
} from "@/utils/common";
import "./index.less";

const SERVER_URL = "https://km.sankuai.com/plantuml/svg/";

const isContainsByTags = (node, tags) => {
  let { parentNode } = node;
  while (parentNode && parentNode.className !== prefixPk("view-container")) {
    if (tags.includes((parentNode.tagName || "").toLowerCase())) {
      return parentNode;
    }
    parentNode = parentNode.parentNode;
  }
  return false;
};

export default class plantumlRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("plantuml")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    const content = node.getAttribute("data-content");
    const width = node.getAttribute("data-width");
    const height = node.getAttribute("data-height");
    const border = node.getAttribute("data-border");
    const encoded = plantumlEncoder.encode(decodeURI(content));

    const $img = document.createElement("img");
    $img.setAttribute("data-src", `${SERVER_URL}${encoded}`);
    $img.setAttribute("data-width", width);
    $img.setAttribute("data-height", `${height}`);
    node.appendChild($img);

    if (border) {
      node.classList.add("border");
    }
  };

  containerRender = ($container: HTMLElement, config) => {
    const imgs = $container.querySelectorAll(`.${prefixCt("plantuml")}>img`);
    const maxWidth = config.maxWidth || window.innerWidth;
    Array.from(imgs).forEach((img: any) => {
      if (!img.hasAttribute("data-src")) return;

      const dataWidth = parseInt(img.getAttribute("data-width"), 10);
      const parentNodeWithTable = isContainsByTags(img, ["td", "th"]);

      if (parentNodeWithTable || !dataWidth) {
        img.parentNode.style.cssText = "max-width: 100%";
      }

      if (dataWidth < maxWidth) {
        img.width = dataWidth;
        img.parentNode.style.cssText = `width: ${dataWidth}px`;
      } else {
        img.parentNode.style.cssText = "width: 100%;";
      }

      // 懒加载则先不设置src
      if (!config.lazyload) {
        img.src = img.getAttribute("data-src");
      }
      img.onerror = (e) => {
        e.target.classList.add(prefixCt("img-failed"));
      };
    });
  };
}
